module.exports = __webpack_public_path__ + "static/Apercu-BoldItalic-a08190754cc00bf854e6cd6e75c1a25d.eot";